import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FsiPickerModal from '~/components/fsi-picker/FsiPickerModal'

interface ActionData {
  name?: string
  id?: number | string
}

interface StepItem {
  actionData?: ActionData
  [key: string]: any
}

interface SelectDestFolderFieldProps {
  item: StepItem
  updateStep: (item: StepItem, index: number) => void
  index: number
  isDisabled?: boolean
}

function SelectDestFolderField({ item, updateStep, index, isDisabled }: SelectDestFolderFieldProps) {
  const [isMoveDialogOpen, setIsMoveDialogOpen] = useState(false)
  const { t: translate } = useTranslation()

  return (
    <div style={{ zIndex: 9999, maxWidth: '20rem' }}>
      <FsiPickerModal
        options={{
          selector: 'folder',
          showRC: true,
          showSystem: true,
          selectedId: item.actionData && item.actionData.id ? item.actionData.id : null,
          leafIds: item.actionData && item.actionData.id ? [item.actionData.id] : null
        }}
        title={translate('SELECT_FOLDER')}
        isOpen={isMoveDialogOpen}
        onClose={() => {
          setIsMoveDialogOpen(false)
        }}
        onSelect={(fsi) => {
          setIsMoveDialogOpen(false)

          item.actionData = { name: fsi.name, id: fsi.id }
          updateStep(item, index)
        }}
      />

      <strong className="mr10">{translate('BROWSER_FILE_SETTINGS_APPROVERS_DESTINATION_FOLDER_LABEL')}:</strong>
      <span
        className={'fsi-picker-input' + (item.actionData && item.actionData.name ? '' : ' empty')}
        onClick={() => {
          !isDisabled ? setIsMoveDialogOpen(true) : null
        }}
      >
        <span>{item.actionData && item.actionData.name ? item.actionData.name : translate('-SELECT_FOLDER-')}</span>
      </span>
    </div>
  )
}

export default SelectDestFolderField
